export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mobile_apps.c179de0.svg";